export default {"src":"/_next/static/media/gardenLand.a1eb00b7.svg","height":105,"width":734,"blurWidth":0,"blurHeight":0};